import { FC } from 'react';
import {
  StyledDialog,
  CloseIconBox,
  HeaderBox,
  AlertIcon,
  Divider,
  SecondaryText,
  ButtonContainer,
  ConfirmButton,
} from '../ConfirmationDialogV2/ConfirmationDialogV2.styles';
import {
  Title,
  SubTitle,
} from '../UpdateChequeStatusDialog/UpdateChequeStatusDialog.styles';

export interface InfoDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  subtitleSecondary?: string;
  confirmText?: string;
  confirmButtonColor?: string;
  iconColor?: string;
}

const InfoDialog: FC<InfoDialogProps> = ({
  open,
  onClose,
  title,
  subtitle,
  subtitleSecondary,
  confirmText = 'OK',
  confirmButtonColor = '#4169E1',
  iconColor = '#4169E1',
}) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <CloseIconBox
        component="i"
        className="bx bx-x-circle"
        onClick={onClose}
      />

      <HeaderBox>
        <AlertIcon
          component="i"
          className="bx bx-info-circle"
          iconColor={iconColor}
        />
        <Title>{title}</Title>
      </HeaderBox>

      <Divider />

      <SubTitle>{subtitle}</SubTitle>
      {subtitleSecondary && <SecondaryText>{subtitleSecondary}</SecondaryText>}

      <ButtonContainer>
        <ConfirmButton onClick={onClose} btnColor={confirmButtonColor}>
          {confirmText}
        </ConfirmButton>
      </ButtonContainer>
    </StyledDialog>
  );
};

export default InfoDialog;
